import { ShapeDataModel, STPlaceholderType, DataType } from '@tencent/slide-sdk-model';
import { IPlaceholderShapeDataModel } from '@tencent/slide-sdk-model/src/model/group-shape-data-model';
import i18n from '@i18next/i18n';
import { getCookieUid } from '@tencent/tencent-doc-report';
import { getCookie } from 'sutils';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { getQuerySearchParams } from '@src/slide/infrastructure/module/independent/url/param-operation';
import { ILocalEditContext } from '../core/interfaces/local-edit-context.interface';

export class LocalEditContext implements ILocalEditContext {
    private traceId = 0;
    private initAt = Date.now();

    public getLocalEditServicesRegisterTime() {
        return this.initAt;
    }

    public getTitle(): string {
        return getQuerySearchParams('title') || i18n.t('空白幻灯片');
    }

    public async getSaveTitle(): Promise<string> {
        let placeholderTitle = '';
        // 新建本地文档首次保存时同步标题预占位标题
        // 桌面端新建文档没有 localFilePath,移动端新建增加 enterEditMode 参数
        if (!this.getLocalFilePath() || this.checkMobileNewCreate()) {
            placeholderTitle = await this.getPlaceholderTitle();
        }
        return placeholderTitle || this.getTitle();
    }

    public getGlobalPadId(): string {
        return getQuerySearchParams('globalPadId');
    }

    public getLocalFilePath(): string {
        return getQuerySearchParams('localFilePath');
    }

    // 移动端新建本地文档 url 增加 enterEditMode 参数
    public checkMobileNewCreate(): boolean {
        return getQuerySearchParams('enterEditMode') === 'true';
    }

    public getUserUin(): string {
        return getCookie('uin') ?? '';
    }

    public getUserUid(): string {
        return getCookieUid() ?? '';
    }

    public getUserInfo(): any {
        return window.basicClientVars?.userInfo;
    }

    public getSecretId(): string {
        return 'local_edit';
    }

    public isLogin(): boolean {
        return !!this.getUserInfo()?.tinyId;
    }

    public createTraceKey(): string {
        this.traceId += 1;
        return `${this.getSessionId()}-${this.traceId}`;
    }

    public getRecoveredType(): string {
        return getQuerySearchParams('recoveredType');
    }

    public getTemplatePath(): string {
        return getQuerySearchParams('templatePath');
    }

    private getSessionId(): string {
        return Math.random().toString(16)
            .slice(2);
    }

    private async getPlaceholderTitle(): Promise<string> {
        const presentationStoreService = await SlideDataServices.SDKDataServices.PresentationStoreService.promise();
        const titleElement = presentationStoreService.getPresentation()
            ?.slideList[0]?.shapeList?.find(element => element.type === DataType.Shape && this.isTitlePh(element));
        return titleElement ? this.getTextStr(titleElement as ShapeDataModel) : '';
    }

    private isTitlePh(sdkData: IPlaceholderShapeDataModel) {
        const placeholderType = sdkData?.props?.nvPr?.ph?.type;
        return placeholderType === STPlaceholderType.title || placeholderType === STPlaceholderType.ctrTitle;
    }

    private getTextStr(sdkData: ShapeDataModel) {
        let textStr = '';
        sdkData.props.txBody?.p?.forEach((paragraph) => {
            if (paragraph.egTextRun) {
                paragraph.egTextRun.forEach((textRun) => {
                    if (textRun?.r?.t) {
                        textStr += textRun.r.t;
                    }
                });
            }
        });
        return textStr.substring(0, 15);
    }
}
